module.exports = __webpack_public_path__ + "img/alliance_logo4.fc036c72.png";